/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
window.flatten = require('flat');
window.angular = require('angular');
require('lodash');
require('ng-currency');
require('jquery-ui/ui/widgets/sortable');
// require('jquery-ui/ui/widgets/sortable');
require('angular-ui-sortable');


// window.swal = require('sweetalert2');
window.ModelService = class ModelService {

    constructor($container, modelPath, prefix = '') {
        this.$container = $container;
        this.$table = this.$container.find('table');
        this.$dummyRow = this.$table.find('.dummy-model-row');
        this.prefix = prefix;
        this.modelPath = modelPath;

        this.$container.find('.btn-add').on('click', () => this.onSubmit())
        this.$container.find('.btn-update').on('click', () => this.onSubmit())

        this.$container.find(".btn-edit").on('click', (e) => {
            e.stopPropagation();

            this.clearForm();
            $tr = $(e.target).closest('tr');
            const model = JSON.parse($tr.attr('model'));

            this.setForm(model);
            this.$container.find(".btn-cancel-edit").show();
            this.$container.find('.btn-add').hide();
            this.$container.find('.btn-update').show();
        });

        this.$container.find('.dummy-model-row .btn-delete').on('click', (e) => {
            $row = $(e.target).closest('tr');
            this.delete($row.attr('model-id'))
        })

        this.$container.find(".btn-cancel-edit").on('click', () => {
            this.clearErrors();
            this.clearForm();

            this.$container.find(".btn-cancel-edit").hide();
        })
    }

    submit() {
        // Override
    }

    afterSetForm(model) {
        // Override
    }

    afterClearForm() {
        // Override
    }

    afterAdd(model = null, $row = null) {
        // Override
    }

    beforeSubmit() {
        this.clearErrors()
    }

    onSubmit() {
        this.beforeSubmit();
        this.submit();
    }

    clearErrors() {
        // console.log('this.$container', this.$container, this.$container.find('.form-group'));
        this.$container.find('.form-group .help-block').remove();
        this.$container.find('.form-group').each((index, item) => {
            $(item).find('.help-block');
            $(item).removeClass('has-error');
        });
    }

    set422Errors(errorDict, prefix = '') {

        for (const prop in errorDict) {

            if (errorDict.hasOwnProperty(prop)) {
                const texts = errorDict[prop];
                const propDotsReplaced = prop.split('.').join('_');

                $formGroupContainer = $(`[name="${prefix}${propDotsReplaced}"]`).closest('div.form-group');

                $helpBlock = $(`<div class="help-block">${texts.map((item) => '<li>' + item + '</li>')}</div>`);

                $formGroupContainer.addClass('has-error');
                $formGroupContainer.append($helpBlock);
            }
        }
    }

    add(model = null) {

        $table = this.$container.find('table');
        $row = this.$dummyRow.clone(true, true);
        $row.removeClass('dummy-model-row');
        $row.show();

        this.setRowProps($row, model);
        $table.append($row);

        this.afterAdd(model, $row);
        this.$container.find('.empty-table-message').hide();
    }

    setRowProps($row, model) {

        const modelFlattened = flatten(model);

        for (let prop in modelFlattened) {
            if (modelFlattened.hasOwnProperty(prop)) {
                const propertyName = prop.split('.').join('_');
                let value = modelFlattened[prop];

                if ($col = $row.find(`td[prop="${propertyName}"]`)) {
                    if ($col.length) {
                        $col.text(value)
                    }
                }
            }
        }

        $row.attr('model', JSON.stringify(this.getModel(model)));
        $row.attr('model-id', model.id);
    }

    update(model = null) {
        $row = this.$container.find(`.model-row[model-id="${model.id}"]`);
        this.setRowProps($row, model);
    }

    delete(id) {
        if (confirm("{{ trans('messages.are_you_sure')}}")) {

            axios.delete(`/admin${this.modelPath}/${id}`).then((resp) => {
                this.$container.find(`[model-id="${id}"]`).remove();

                $idInput = this.$container.find(`input[name="${this.prefix}id"]`)

                if ($idInput) {
                    if ($idInput.val() == id) {
                        this.clearForm()
                    }
                }

            }).catch((err) => {});
        }
    }

    getModel(model) {
        return {
            id: model.id,
            path: model.path,
            filename: model.filename,
            filesize: model.filesize,
        };
    };

    onSubmitSuccess(resp, isUpdate) {
        if (resp.success) {
            isUpdate ? this.update(resp.data) : this.add(resp.data);
        }

        this.clearForm()
    }

    onSubmitFail(err) {
        if (err.status == 422) {
            this.clearErrors(); // global function in show_fields.blade.php
            this.set422Errors(err.responseJSON && err.responseJSON.errors ? err.responseJSON.errors : {}, this.prefix) // global function in show_fields.blade.php
        }
    }

    setForm(model) {

        const modelFlattened = flatten(model);

        for (let prop in modelFlattened) {
            if (modelFlattened.hasOwnProperty(prop)) {
                const propertyName = prop.split('.').join('_');
                const val = modelFlattened[prop];

                $field = this.$container.find(`[name="${this.prefix}${propertyName}"]`);

                if ($field) {
                    $field.val(val);

                    if ($field.prop('tagName') == 'SELECT') {
                        $field.change();
                    }
                }
            }
        }

        this.afterSetForm(model);
    }

    clearForm() {
        this.clearErrors();

        this.$container.find('input').val(null);
        this.$container.find('textarea').val(null);

        this.$container.find('select').each(function (item) {
            $(this).val(null);
            $(this).change();
        })

        this.$container.find(".btn-cancel").hide();
        this.$container.find('.btn-add').show();
        this.$container.find('.btn-update').hide();
        this.$container.find('.btn-cancel-edit').hide();

        this.afterClearForm();
    }
}

// console.log('flatten..', flatten);
